import React from "react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { BUSINESS_INFO } from "../config";

export function NotFoundPage() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet - Hundens Pels og Pleje"
        description="Beklager, den side du leder efter findes desværre ikke hos Hundens Pels og Pleje. Gå til forsiden eller se vores ydelser."
      />

      <section className="flex min-h-[70vh] items-center justify-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="mx-auto max-w-xl text-center">
          <i className="fa-solid fa-bone text-4xl text-black transform -rotate-12 mb-4" aria-hidden="true" />

          <h1 className="font-heading text-3xl sm:text-4xl font-medium text-black tracking-tight">
            Ups! Sporet er blevet væk
          </h1>

          <p className="mt-4 text-base sm:text-lg text-black leading-relaxed">
            Vi kan desværre ikke finde siden, du leder efter. Den kan være flyttet, eller også har en nysgerrig hvalp gravet den ned i haven.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full bg-[#dabeb9] px-6 py-3.5 text-sm font-bold text-black shadow-xs transition-colors hover:bg-[#c9a7a0]"
            >
              <i className="fa-solid fa-house text-black" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            {/* Secondary CTA: NO background color, NO hover background color */}
            <Link
              to="/ydelser-priser"
              className="inline-flex items-center gap-2 rounded-full border border-black bg-transparent px-6 py-3.5 text-sm font-semibold text-black transition-colors hover:bg-transparent hover:text-black hover:border-black"
            >
              <i className="fa-solid fa-scissors text-black" aria-hidden="true" />
              <span>Se ydelser & priser</span>
            </Link>

            <a
              href={BUSINESS_INFO.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#dabeb9] px-6 py-3.5 text-sm font-bold text-black shadow-xs transition-colors hover:bg-[#c9a7a0]"
            >
              <i className="fa-solid fa-calendar-check text-black" aria-hidden="true" />
              <span>Book tid</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
